'use strict';

var _regeneratorRuntime = require("@babel/runtime/regenerator");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _class, _getPostResponseFunc, _getUrl, _errorHandler, _temp;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var fetchWithNetworkError = require('@uppy/utils/lib/fetchWithNetworkError');

var AuthError = require("./AuthError"); // Remove the trailing slash so we can always safely append /xyz.


function stripSlash(url) {
  return url.replace(/\/$/, '');
}

function handleJSONResponse(_x) {
  return _handleJSONResponse.apply(this, arguments);
}

function _handleJSONResponse() {
  _handleJSONResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
    var jsonPromise, errMsg, errData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(res.status === 401)) {
              _context.next = 2;
              break;
            }

            throw new AuthError();

          case 2:
            jsonPromise = res.json();

            if (!(res.status < 200 || res.status > 300)) {
              _context.next = 14;
              break;
            }

            errMsg = "Failed request with status: ".concat(res.status, ". ").concat(res.statusText);
            _context.prev = 5;
            _context.next = 8;
            return jsonPromise;

          case 8:
            errData = _context.sent;
            errMsg = errData.message ? "".concat(errMsg, " message: ").concat(errData.message) : errMsg;
            errMsg = errData.requestId ? "".concat(errMsg, " request-Id: ").concat(errData.requestId) : errMsg;

          case 11:
            _context.prev = 11;
            throw new Error(errMsg);

          case 14:
            return _context.abrupt("return", jsonPromise);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5,, 11, 14]]);
  }));
  return _handleJSONResponse.apply(this, arguments);
}

module.exports = (_temp = (_getPostResponseFunc = /*#__PURE__*/_classPrivateFieldLooseKey("getPostResponseFunc"), _getUrl = /*#__PURE__*/_classPrivateFieldLooseKey("getUrl"), _errorHandler = /*#__PURE__*/_classPrivateFieldLooseKey("errorHandler"), _class = /*#__PURE__*/function () {
  // eslint-disable-next-line global-require
  function RequestClient(uppy, opts) {
    var _this = this;

    _classCallCheck(this, RequestClient);

    Object.defineProperty(this, _errorHandler, {
      value: _errorHandler2
    });
    Object.defineProperty(this, _getUrl, {
      value: _getUrl2
    });
    Object.defineProperty(this, _getPostResponseFunc, {
      writable: true,
      value: function value(skip) {
        return function (response) {
          return skip ? response : _this.onReceiveResponse(response);
        };
      }
    });
    this.uppy = uppy;
    this.opts = opts;
    this.onReceiveResponse = this.onReceiveResponse.bind(this);
    this.allowedHeaders = ['accept', 'content-type', 'uppy-auth-token'];
    this.preflightDone = false;
  }

  _createClass(RequestClient, [{
    key: "hostname",
    get: function get() {
      var _this$uppy$getState = this.uppy.getState(),
          companion = _this$uppy$getState.companion;

      var host = this.opts.companionUrl;
      return stripSlash(companion && companion[host] ? companion[host] : host);
    }
  }, {
    key: "headers",
    value: function headers() {
      var userHeaders = this.opts.companionHeaders || {};
      return Promise.resolve(_objectSpread(_objectSpread({}, RequestClient.defaultHeaders), userHeaders));
    }
  }, {
    key: "onReceiveResponse",
    value: function onReceiveResponse(response) {
      var state = this.uppy.getState();
      var companion = state.companion || {};
      var host = this.opts.companionUrl;
      var headers = response.headers; // Store the self-identified domain name for the Companion instance we just hit.

      if (headers.has('i-am') && headers.get('i-am') !== companion[host]) {
        this.uppy.setState({
          companion: _objectSpread(_objectSpread({}, companion), {}, _defineProperty({}, host, headers.get('i-am')))
        });
      }

      return response;
    }
  }, {
    key: "preflight",
    value: function preflight(path) {
      var _this2 = this;

      if (this.preflightDone) {
        return Promise.resolve(this.allowedHeaders.slice());
      }

      return fetch(_classPrivateFieldLooseBase(this, _getUrl)[_getUrl](path), {
        method: 'OPTIONS'
      }).then(function (response) {
        if (response.headers.has('access-control-allow-headers')) {
          _this2.allowedHeaders = response.headers.get('access-control-allow-headers').split(',').map(function (headerName) {
            return headerName.trim().toLowerCase();
          });
        }

        _this2.preflightDone = true;
        return _this2.allowedHeaders.slice();
      }).catch(function (err) {
        _this2.uppy.log("[CompanionClient] unable to make preflight request ".concat(err), 'warning');

        _this2.preflightDone = true;
        return _this2.allowedHeaders.slice();
      });
    }
  }, {
    key: "preflightAndHeaders",
    value: function preflightAndHeaders(path) {
      var _this3 = this;

      return Promise.all([this.preflight(path), this.headers()]).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            allowedHeaders = _ref2[0],
            headers = _ref2[1]; // filter to keep only allowed Headers


        Object.keys(headers).forEach(function (header) {
          if (!allowedHeaders.includes(header.toLowerCase())) {
            _this3.uppy.log("[CompanionClient] excluding disallowed header ".concat(header));

            delete headers[header]; // eslint-disable-line no-param-reassign
          }
        });
        return headers;
      });
    }
  }, {
    key: "get",
    value: function get(path, skipPostResponse) {
      var _this4 = this;

      var method = 'get';
      return this.preflightAndHeaders(path).then(function (headers) {
        return fetchWithNetworkError(_classPrivateFieldLooseBase(_this4, _getUrl)[_getUrl](path), {
          method: method,
          headers: headers,
          credentials: _this4.opts.companionCookiesRule || 'same-origin'
        });
      }).then(_classPrivateFieldLooseBase(this, _getPostResponseFunc)[_getPostResponseFunc](skipPostResponse)).then(handleJSONResponse).catch(_classPrivateFieldLooseBase(this, _errorHandler)[_errorHandler](method, path));
    }
  }, {
    key: "post",
    value: function post(path, data, skipPostResponse) {
      var _this5 = this;

      var method = 'post';
      return this.preflightAndHeaders(path).then(function (headers) {
        return fetchWithNetworkError(_classPrivateFieldLooseBase(_this5, _getUrl)[_getUrl](path), {
          method: method,
          headers: headers,
          credentials: _this5.opts.companionCookiesRule || 'same-origin',
          body: JSON.stringify(data)
        });
      }).then(_classPrivateFieldLooseBase(this, _getPostResponseFunc)[_getPostResponseFunc](skipPostResponse)).then(handleJSONResponse).catch(_classPrivateFieldLooseBase(this, _errorHandler)[_errorHandler](method, path));
    }
  }, {
    key: "delete",
    value: function _delete(path, data, skipPostResponse) {
      var _this6 = this;

      var method = 'delete';
      return this.preflightAndHeaders(path).then(function (headers) {
        return fetchWithNetworkError("".concat(_this6.hostname, "/").concat(path), {
          method: method,
          headers: headers,
          credentials: _this6.opts.companionCookiesRule || 'same-origin',
          body: data ? JSON.stringify(data) : null
        });
      }).then(_classPrivateFieldLooseBase(this, _getPostResponseFunc)[_getPostResponseFunc](skipPostResponse)).then(handleJSONResponse).catch(_classPrivateFieldLooseBase(this, _errorHandler)[_errorHandler](method, path));
    }
  }]);

  return RequestClient;
}()), _class.VERSION = "2.0.4", _class.defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Uppy-Versions': "@uppy/companion-client=".concat(_class.VERSION)
}, _temp);

function _getUrl2(url) {
  if (/^(https?:|)\/\//.test(url)) {
    return url;
  }

  return "".concat(this.hostname, "/").concat(url);
}

function _errorHandler2(method, path) {
  var _this7 = this;

  return function (err) {
    var _err;

    if (!((_err = err) != null && _err.isAuthError)) {
      var error = new Error("Could not ".concat(method, " ").concat(_classPrivateFieldLooseBase(_this7, _getUrl)[_getUrl](path)));
      error.cause = err;
      err = error; // eslint-disable-line no-param-reassign
    }

    return Promise.reject(err);
  };
}